<div class="box-menu-settings" [class.active]="isEocCut">

	<div class="row-box">
		<h4>{{ labels().TOOLS_MENU_COMPONENT_TEMPLATE }}</h4>
		@if (isPlateInserted) {
		<div class="check-success ms-auto"></div>
		}
	</div>

	<div class="divider-box"></div>

	@if (stateType !== stateTypeEnum.templating) {
	<div data-testid="SUBSYS4_JPSMENU_ACTIVATE_BTN" class="row-box"
		[class]="{'clickable': isEocCut, 'not-allowed': !isEocCut }" (click)="enableTemplate()"
		(keypress)="enableTemplate()">
		<i class="material-icons">more_horiz</i>
		<span>{{ labels().TOOLS_MENU_COMPONENT_ACTIVATE }}</span>
	</div>
	} @else {
	<div data-testid="SUBSYS4_JPSMENU_TEMPLATE_BTN" class="row-box clickable" (click)="openTemplateSelection()"
		(keypress)="openTemplateSelection()">
		<div class="fake-material-icon template"></div>
		<span>{{ labels().TOOLS_MENU_COMPONENT_JPS_PRODUCT }}</span>
	</div>
	}

</div>